/* GET SIZE - Helper */
// Get the size of an object, returns object with width & height
// If no object, defaults to viewport dimensions
// Immeiate usage:
// objectWidth = getSize().w
// objectHeight = getSize().h
// or keep both values
// myObject =  getSize()
// Use the following way: myObject.w, myObject.h
function getSize(element){
  var w = (element) ? Math.max(element.clientWidth, element.innerWidth || 0) : Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
  var h = (element) ? Math.max(element.clientHeight, element.innerHeight || 0) : Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
  
  return  { w: w, h: h };
}